import React, { useState, useEffect } from 'react';
import { documentoService } from '../services/api';
import { Documento } from '../models/types';
import './DocumentiPage.css';

const DocumentiPage: React.FC = () => {
  const [documenti, setDocumenti] = useState<Documento[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadDocumenti();
  }, []);

  const loadDocumenti = async () => {
    try {
      setLoading(true);
      const data = await documentoService.getAll();
      setDocumenti(data);
      setError(null);
    } catch (err) {
      setError('Errore durante il caricamento dei documenti');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Caricamento documenti...</div>;
  }

  if (error) {
    return (
      <div className="error">
        <p>{error}</p>
        <button className="btn btn-primary" onClick={loadDocumenti}>
          Riprova
        </button>
      </div>
    );
  }

  return (
    <div className="documenti-page">
      <div className="page-header">
        <h1>?? Documenti</h1>
        <button className="btn btn-primary" onClick={loadDocumenti}>
          Aggiorna
        </button>
      </div>

      {documenti.length === 0 ? (
        <div className="empty-state">
          <p>Nessun documento trovato</p>
        </div>
      ) : (
        <div className="card">
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Numero</th>
                <th>Data</th>
                <th>Cliente</th>
                <th>Importo</th>
                <th>Stato</th>
              </tr>
            </thead>
            <tbody>
              {documenti.map((doc) => (
                <tr key={doc.id}>
                  <td>{doc.id}</td>
                  <td>{doc.numero}</td>
                  <td>{new Date(doc.data).toLocaleDateString('it-IT')}</td>
                  <td>{doc.cliente}</td>
                  <td>� {doc.importo.toFixed(2)}</td>
                  <td>
                    <span className={`status status-${doc.stato.toLowerCase()}`}>
                      {doc.stato}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DocumentiPage;
